(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSlider(slider) {
    if (slider.dataset.bound === 'true') return;
    slider.dataset.bound = 'true';

    var before = slider.querySelector('[data-ba-before]');
    var handle = slider.querySelector('[data-ba-handle]');
    var hint = slider.querySelector('.ba-slider__hint');
    var labelBefore = slider.querySelector('.ba-slider__label--before');
    var labelAfter = slider.querySelector('.ba-slider__label--after');
    if (!before || !handle) return;

    var position = 50;
    var isDragging = false;
    var hasInteracted = false;

    // Thresholds: con qué % de slider el label opuesto se desvanece
    var HIDE_AFTER_AT  = 88;  // si pct >= 88 (mostrando ANTES) → ocultar label DESPUÉS
    var HIDE_BEFORE_AT = 12;  // si pct <= 12 (mostrando DESPUÉS) → ocultar label ANTES

    function setPosition(pct) {
      pct = Math.max(0, Math.min(100, pct));
      position = pct;

      // Clip del before: cuanto mayor el pct, menos clip (más BEFORE visible a la izquierda)
      before.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      handle.style.left = pct + '%';
      handle.setAttribute('aria-valuenow', Math.round(pct));

      // Fade de labels según extremo
      if (labelBefore) labelBefore.style.opacity = pct > HIDE_BEFORE_AT ? '1' : '0';
      if (labelAfter)  labelAfter.style.opacity  = pct < HIDE_AFTER_AT  ? '1' : '0';

      if (!hasInteracted) {
        hasInteracted = true;
        if (hint) hint.style.opacity = '0';
      }
    }

    function getPercent(x) {
      var r = slider.getBoundingClientRect();
      return ((x - r.left) / r.width) * 100;
    }

    function onDown(e) {
      isDragging = true;
      slider.classList.add('is-dragging');
      e.preventDefault();
      var x = e.touches ? e.touches[0].clientX : e.clientX;
      setPosition(getPercent(x));
    }
    function onMove(e) {
      if (!isDragging) return;
      var x = e.touches ? e.touches[0].clientX : e.clientX;
      setPosition(getPercent(x));
    }
    function onUp() {
      isDragging = false;
      slider.classList.remove('is-dragging');
    }

    slider.addEventListener('mousedown', onDown);
    slider.addEventListener('touchstart', onDown, { passive: false });
    document.addEventListener('mousemove', onMove);
    document.addEventListener('touchmove', onMove, { passive: true });
    document.addEventListener('mouseup', onUp);
    document.addEventListener('touchend', onUp);

    handle.addEventListener('keydown', function (e) {
      var step = e.shiftKey ? 10 : 2;
      if (e.key === 'ArrowLeft' || e.key === 'ArrowDown')      { e.preventDefault(); setPosition(position - step); }
      else if (e.key === 'ArrowRight' || e.key === 'ArrowUp')  { e.preventDefault(); setPosition(position + step); }
      else if (e.key === 'Home')                                { e.preventDefault(); setPosition(0); }
      else if (e.key === 'End')                                 { e.preventDefault(); setPosition(100); }
    });

    setPosition(50);
    if (hint) setTimeout(function () { if (!hasInteracted) hint.classList.add('is-pulsing'); }, 1000);
  }

  document.querySelectorAll('[data-ba-slider]').forEach(initSlider);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-ba-slider]').forEach(initSlider);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Gallery
  function initGallery(gallery) {
    if (gallery.dataset.bound === 'true') return;
    gallery.dataset.bound = 'true';
    var slides = gallery.querySelectorAll('[data-hero-slide]');
    var dots = gallery.querySelectorAll('[data-hero-dot]');
    var prev = gallery.querySelector('[data-hero-prev]');
    var next = gallery.querySelector('[data-hero-next]');
    var thumbsContainer = gallery.parentElement.querySelector('.hero-product__thumbs');
    var thumbs = thumbsContainer ? thumbsContainer.querySelectorAll('[data-hero-thumb]') : [];
    if (slides.length < 2) return;
    var current = 0, total = slides.length;
    function go(idx) {
      idx = (idx + total) % total;
      slides.forEach(function (s, i) {
        s.classList.toggle('is-active', i === idx);
        if (i !== idx) s.setAttribute('aria-hidden', 'true');
        else s.removeAttribute('aria-hidden');
      });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      current = idx;
    }
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    var startX = 0, isTouching = false;
    gallery.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; isTouching = true; }, { passive: true });
    gallery.addEventListener('touchend', function (e) {
      if (!isTouching) return;
      var diff = e.changedTouches[0].clientX - startX;
      if (Math.abs(diff) > 50) go(current + (diff < 0 ? 1 : -1));
      isTouching = false;
    });
  }

  // Bundle selector + add to cart
  function initBundles(container) {
    if (container.dataset.bound === 'true') return;
    container.dataset.bound = 'true';

    var radios = container.querySelectorAll('[data-bundle-radio]');
    var cards = container.querySelectorAll('[data-bundle-card]');
    var addBtn = container.querySelector('[data-hero-bundles-add]');

    // Mensajes del boton: salen de los ajustes de la seccion ("Mensajes del
    // boton"); si vienen vacios se usa el texto de siempre.
    function txt(key, fallback) {
      return container.getAttribute('data-text-' + key) || fallback;
    }

    // Aviso para el desarrollador: si algun plan todavia se resuelve por
    // posicion, queda expuesto a que cambie solo al reordenar variantes.
    Array.prototype.forEach.call(radios, function (r) {
      var how = r.getAttribute('data-bundle-match');
      if (how === 'index' || how === 'fallback') {
        console.warn('[uvora] El plan "' + (r.getAttribute('data-bundle-title') || '?') +
          '" se resolvio por ' + how + '. Cargale el ID de variante en el Theme Editor.');
      }
    });

    function formatMoney(cents) {
      var amount = cents / 100;
      var formatted = Math.round(amount).toLocaleString('es-AR');
      return '$' + formatted;
    }
    function updateCardPrice(card) { /* no-op */ }

    // Arma el payload de /cart/add.js para la tarjeta seleccionada.
    // Lo usan POR IGUAL el boton principal de esta seccion y el sticky ATC
    // (que lo recibe por el evento bundle:selected), asi las dos vias de
    // compra no pueden quedar desincronizadas nunca mas.
    function buildItems(selected) {
      var items = [];
      var upsellIds = [];
      if (!selected || !selected.value) return { items: items, upsellIds: upsellIds };
      items.push({ id: parseInt(selected.value, 10), quantity: 1 });
      var card = selected.closest('[data-bundle-card]');
      if (card) {
        card.querySelectorAll('[data-bundle-upsell].is-checked').forEach(function (up) {
          var vid = up.getAttribute('data-upsell-variant-id');
          if (!vid) return;
          var parsed = parseInt(vid, 10);
          if (!isNaN(parsed) && parsed > 0) {
            items.push({ id: parsed, quantity: 1 });
            upsellIds.push(parsed);
          }
        });
      }
      return { items: items, upsellIds: upsellIds };
    }

    // Avisa al resto de la pagina (sticky ATC) que cambio el plan elegido.
    // Regla 34: CustomEvent global, nunca acoplar el DOM de dos secciones.
    // Se llama SIEMPRE desde updateSelection(), asi que no depende del evento
    // 'change' nativo del radio -- que no se dispara cuando el comprador toca
    // la tarjeta y el JS pone .checked a mano (era la causa del bug).
    function emitBundleSelected() {
      var selected = container.querySelector('[data-bundle-radio]:checked');
      if (!selected) return;
      var card = selected.closest('[data-bundle-card]');
      var img = card ? card.querySelector('.hero-bundle-card__media img') : null;
      var payload = buildItems(selected);
      var detail = {
        variantId: selected.value,
        priceCents: parseInt(selected.getAttribute('data-price-cents'), 10) || 0,
        compareAtCents: parseInt(selected.getAttribute('data-compare-cents'), 10) || 0,
        priceText: selected.getAttribute('data-price-text') || '',
        compareText: selected.getAttribute('data-compare-text') || '',
        title: selected.getAttribute('data-bundle-title') || '',
        imageUrl: img ? img.src : '',
        items: payload.items,
        upsellIds: payload.upsellIds
      };
      // El sticky ATC es la ULTIMA seccion del template y puede inicializarse
      // despues de este emit, perdiendose el evento. Dejamos el ultimo estado
      // en window para que lo lea al arrancar.
      window.UvoraBundleState = detail;
      document.dispatchEvent(new CustomEvent('bundle:selected', { detail: detail }));
    }

    async function fetchUpsellPrices(card) {
      var upsells = card.querySelectorAll('[data-bundle-upsell][data-upsell-variant-id]');
      await Promise.all(Array.from(upsells).map(async function (up) {
        if (up.getAttribute('data-upsell-price')) return;
        var vid = up.getAttribute('data-upsell-variant-id');
        try {
          var res = await fetch('/variants/' + vid + '.js');
          if (!res.ok) return;
          var data = await res.json();
          if (data && data.price) up.setAttribute('data-upsell-price', data.price);
        } catch (e) {}
      }));
      updateCardPrice(card);
    }

    function registerBundleUpsellPairs(bundleVariantId, upsellVariantIds) {
      try {
        var pairs = JSON.parse(sessionStorage.getItem('uvora_bundle_pairs') || '[]');
        pairs = pairs.filter(function (p) { return p.bundle !== bundleVariantId; });
        if (upsellVariantIds.length > 0) {
          pairs.push({ bundle: bundleVariantId, upsells: upsellVariantIds });
        }
        sessionStorage.setItem('uvora_bundle_pairs', JSON.stringify(pairs));
      } catch (e) {}
    }

    async function enforceCartBundleUpsells(cart) {
      try {
        var pairs = JSON.parse(sessionStorage.getItem('uvora_bundle_pairs') || '[]');
        if (!pairs.length) return;
        var cartVariantIds = (cart.items || []).map(function (i) { return String(i.variant_id); });
        var toRemove = [];
        pairs.forEach(function (pair) {
          if (!cartVariantIds.includes(String(pair.bundle))) {
            pair.upsells.forEach(function (uid) {
              if (cartVariantIds.includes(String(uid))) toRemove.push(String(uid));
            });
          }
        });
        if (!toRemove.length) return;
        var updates = {};
        toRemove.forEach(function (uid) { updates[uid] = 0; });
        var res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
        if (res.ok) {
          var newCart = await res.json();
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: newCart }));
        }
      } catch (e) {}
    }

    function resetCardUpsells(card) {
      card.querySelectorAll('[data-bundle-upsell]').forEach(function (up) {
        var isAlwaysOn = up.getAttribute('data-upsell-always-on') === 'true';
        var isDefault = up.getAttribute('data-upsell-default-checked') === 'true';
        var shouldBeChecked = isAlwaysOn || isDefault;
        var cb = up.querySelector('[data-upsell-checkbox]');
        if (cb) cb.checked = shouldBeChecked;
        if (shouldBeChecked) up.classList.add('is-checked');
        else up.classList.remove('is-checked');
      });
      updateCardPrice(card);
    }

    function updateSelection() {
      cards.forEach(function (card) {
        var input = card.querySelector('[data-bundle-radio]');
        var wasSelected = card.classList.contains('is-selected');
        var isSelected = !!(input && input.checked);
        if (isSelected) {
          card.classList.add('is-selected');
          if (!wasSelected) {
            resetCardUpsells(card);
            fetchUpsellPrices(card);
          }
        } else {
          card.classList.remove('is-selected');
        }
      });
      emitBundleSelected();
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (e.target.closest('[data-bundle-upsell]')) return;
        var input = card.querySelector('[data-bundle-radio]');
        if (input && !input.disabled && !input.checked) {
          input.checked = true;
          updateSelection();
        }
      });

      card.querySelectorAll('[data-bundle-upsell]').forEach(function (up) {
        var cb = up.querySelector('[data-upsell-checkbox]');
        if (!cb) return;
        if (up.getAttribute('data-upsell-always-on') === 'true') {
          up.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); });
          return;
        }
        cb.addEventListener('change', function () {
          if (cb.checked) up.classList.add('is-checked');
          else up.classList.remove('is-checked');
          updateCardPrice(card);
          // Tildar/destildar un upsell cambia el pedido: re-avisar al sticky.
          emitBundleSelected();
        });
      });

      if (card.classList.contains('is-selected')) {
        resetCardUpsells(card);
        fetchUpsellPrices(card);
      }
    });

    radios.forEach(function (r) { r.addEventListener('change', updateSelection); });

    // Expuesto para que el sticky ATC registre los mismos pares bundle-upsell
    // que registra esta seccion (sino enforceCartBundleUpsells borra de mas).
    window.UvoraBundles = { registerPairs: registerBundleUpsellPairs };

    // Estado inicial: deja window.UvoraBundleState listo antes de que el
    // sticky ATC se inicialice.
    emitBundleSelected();

    document.addEventListener('cart:updated', function (e) {
      if (e.detail) enforceCartBundleUpsells(e.detail);
    });

    // Mensaje inline en vez de un cartel modal del navegador: el modal corta
    // la compra en seco y en mobile se siente como un error de la tienda.
    function showBundleError(msg) {
      // Sin boton visible (compra disparada desde la barra flotante) el aviso
      // va al carrito lateral, que es lo que el comprador esta mirando.
      if (!addBtn) {
        if (window.UvoraCart && window.UvoraCart.error) window.UvoraCart.error(msg);
        else console.error('[uvora]', msg);
        return;
      }
      var box = container.querySelector('[data-bundles-error]');
      if (!box) {
        box = document.createElement('p');
        box.setAttribute('data-bundles-error', '');
        box.setAttribute('role', 'alert');
        box.style.cssText = 'margin:8px 0 0;text-align:center;font-size:13px;color:var(--hb-add-bg,currentColor);';
        addBtn.parentNode.appendChild(box);
      }
      box.textContent = msg;
      box.style.display = '';
      clearTimeout(box.__t);
      box.__t = setTimeout(function () { box.style.display = 'none'; }, 5000);
    }

    // Que se compra al apretar el boton:
    // - con los planes del tema visibles: el plan tildado + sus upsells;
    // - sin planes (ocultos, borrados, o reemplazados por una app): la
    //   variante que tenga en ese momento el campo "id" del formulario de
    //   producto. Ese campo es el que actualizan las apps de bundles.
    function readFormPayload() {
      if (!productForm) return null;
      var idField = productForm.elements.namedItem('id');
      var qtyField = productForm.elements.namedItem('quantity');
      var vid = parseInt(idField && idField.value, 10);
      if (!(vid > 0)) return null;
      var qty = parseInt(qtyField && qtyField.value, 10);
      if (!(qty > 0)) qty = 1; /* Kaching escribe la cantidad del pack en el form que contiene su widget (el del sticky), no en este: se toma la mayor cantidad declarada para esta misma variante. Si la variante ya es lleva 2 o lleva 3 no se multiplica (evita mandar 4 o 9 frascos). */ try { var vTitle = ''; var vdEl = document.querySelector('[data-sticky-variants]'); if (vdEl) { var vMap = JSON.parse(vdEl.textContent) || {}; vTitle = (vMap[vid] && vMap[vid].title) || ''; } if (/lleva\s*[2-9]/i.test(vTitle)) { qty = 1; } else { Array.prototype.forEach.call(document.querySelectorAll('form[action*="/cart/add"]'), function (f) { var fId = f.elements.namedItem('id'); var fQty = f.elements.namedItem('quantity'); if (!fId || !fQty || parseInt(fId.value, 10) !== vid) return; var n = parseInt(fQty.value, 10); if (n > qty && n <= 10) qty = n; }); } } catch (e) {} return { variantId: vid, items: [{ id: vid, quantity: qty }], upsellIds: [] };
    }

    var busy = false;

    async function submitBundle() {
      if (busy) return;

      var bundleVariantId, payload;
      if (radios.length) {
        var selected = container.querySelector('[data-bundle-radio]:checked');
        if (!selected || !selected.value) {
          showBundleError(txt('no-plan', 'Elegi un plan para continuar.'));
          return;
        }
        bundleVariantId = parseInt(selected.value, 10);
        payload = buildItems(selected);
      } else {
        payload = readFormPayload();
        if (!payload) {
          showBundleError(txt('no-plan', 'Elegi un plan para continuar.'));
          return;
        }
        bundleVariantId = payload.variantId;
      }

      registerBundleUpsellPairs(String(bundleVariantId), payload.upsellIds.map(String));

      busy = true;
      if (addBtn) addBtn.setAttribute('aria-busy', 'true');
      var txtSpan = addBtn ? addBtn.querySelector('.add-to-cart-text') : null;
      var originalText = txtSpan ? txtSpan.textContent : '';
      if (txtSpan) txtSpan.textContent = txt('adding', 'Agregando...');

      try {
        // Toda la compra pasa por UvoraCart.addBundle (theme.js): saca del
        // carrito las lineas viejas de este producto, agrega el plan elegido,
        // repinta el drawer y recien ahi lo abre. Antes esto abria el drawer
        // a mano y simulaba un click en el icono del header para que se
        // repintara -- si ese click no llegaba, el comprador veia "carrito
        // vacio" con el pedido ya cargado.
        if (!window.UvoraCart) throw new Error('cart-api-missing');
        await window.UvoraCart.addBundle({
          items: payload.items,
          replaceProductId: container.getAttribute('data-bundle-product-id')
        });
        if (txtSpan) txtSpan.textContent = originalText;
      } catch (err) {
        console.error(err);
        if (txtSpan) txtSpan.textContent = originalText;
        // Si theme.js no cargo, dejamos que el form postee nativo a
        // /cart/add: la compra se concreta igual (regla 60).
        if (err && err.message === 'cart-api-missing' && productForm) {
          productForm.submit();
          return;
        }
        showBundleError(err.message || txt('error', 'Hubo un problema. Proba de nuevo.'));
      } finally {
        busy = false;
        if (addBtn) addBtn.removeAttribute('aria-busy');
      }
    }

    // El boton es type="submit" del form de producto (atributo form="").
    // Interceptamos el submit para hacerlo por AJAX. Si este JS no corre, el
    // form postea nativo y la compra igual funciona (regla 60).
    // - Si otro script (una app de bundles) ya atendio el submit y lo cancelo,
    //   no agregamos de nuevo: un solo /cart/add por click (regla 78).
    // - Modo "Envio normal de Shopify": no interceptamos nada y el form se
    //   envia tal cual, para que la app maneje la compra a su manera.
    var productForm = document.getElementById(container.getAttribute('data-form-id') || '') ||
                      container.querySelector('form');
    var atcHandler = container.getAttribute('data-atc-handler') || 'theme';
    if (productForm) {
      productForm.addEventListener('submit', function (e) {
        if (e.defaultPrevented || atcHandler === 'native') return;
        e.preventDefault();
        submitBundle();
      });
    } else if (addBtn) {
      addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        submitBundle();
      });
    }
  }

  // FAQ con auto-cierre (single-open): al abrir una, las otras se cierran
  function initFaq(list) {
    if (list.dataset.bound === 'true') return;
    list.dataset.bound = 'true';
    if (list.dataset.singleOpen !== 'true') return;
    var items = list.querySelectorAll('.hero-faq__item');
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (item.open) {
          items.forEach(function (other) { if (other !== item) other.open = false; });
        }
      });
    });
  }

  document.querySelectorAll('[data-hero-gallery]').forEach(initGallery);
  document.querySelectorAll('[data-hero-buy-root]').forEach(initBundles);
  document.querySelectorAll('.hero-faq__list').forEach(initFaq);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-hero-gallery]').forEach(initGallery);
    e.target.querySelectorAll('[data-hero-buy-root]').forEach(initBundles);
    e.target.querySelectorAll('.hero-faq__list').forEach(initFaq);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Gallery
  function initGallery(gallery) {
    if (gallery.dataset.bound === 'true') return;
    gallery.dataset.bound = 'true';
    var slides = gallery.querySelectorAll('[data-hero-slide]');
    var dots = gallery.querySelectorAll('[data-hero-dot]');
    var prev = gallery.querySelector('[data-hero-prev]');
    var next = gallery.querySelector('[data-hero-next]');
    var thumbsContainer = gallery.parentElement.querySelector('.hero-product__thumbs');
    var thumbs = thumbsContainer ? thumbsContainer.querySelectorAll('[data-hero-thumb]') : [];
    if (slides.length < 2) return;
    var current = 0, total = slides.length;
    function go(idx) {
      idx = (idx + total) % total;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); if (i !== idx) s.setAttribute('aria-hidden', 'true'); else s.removeAttribute('aria-hidden'); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      current = idx;
    }
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    var startX = 0, isTouching = false;
    gallery.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; isTouching = true; }, { passive: true });
    gallery.addEventListener('touchend', function (e) {
      if (!isTouching) return;
      var diff = e.changedTouches[0].clientX - startX;
      if (Math.abs(diff) > 50) go(current + (diff < 0 ? 1 : -1));
      isTouching = false;
    });
  }

  // Bundle selector + add to cart
  function initBundles(container) {
    if (container.dataset.bound === 'true') return;
    container.dataset.bound = 'true';

    var radios = container.querySelectorAll('[data-bundle-radio]');
    var cards = container.querySelectorAll('[data-bundle-card]');
    var addBtn = container.querySelector('[data-hero-bundles-add]');

    function updateSelection() {
      cards.forEach(function (card) {
        var input = card.querySelector('[data-bundle-radio]');
        if (input && input.checked) card.classList.add('is-selected');
        else card.classList.remove('is-selected');
      });
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        // El click en el label naturalmente activa el radio
        // Pero si clickea en otro lado del card, también activa
        var input = card.querySelector('[data-bundle-radio]');
        if (input && !input.disabled && !input.checked) {
          input.checked = true;
          updateSelection();
        }
      });
    });

    radios.forEach(function (r) {
      r.addEventListener('change', updateSelection);
    });

    if (addBtn) {
      addBtn.addEventListener('click', async function (e) {
        e.preventDefault();
        if (addBtn.hasAttribute('aria-busy')) return;

        var selected = container.querySelector('[data-bundle-radio]:checked');
        if (!selected) {
          alert('Elegí un plan primero');
          return;
        }
        if (!selected.value) {
          alert('El producto aún no está configurado. Asegurate que el handle del producto en los settings de la sección coincida con un producto publicado.');
          return;
        }

        var variantId = selected.value;
        addBtn.setAttribute('aria-busy', 'true');
        var txtSpan = addBtn.querySelector('.add-to-cart-text');
        var originalText = txtSpan ? txtSpan.textContent : '';
        if (txtSpan) txtSpan.textContent = 'Agregando...';

        try {
          // Misma via de compra que el resto del tema (theme.js): saca del
          // carrito las lineas viejas de este producto para que quede UN SOLO
          // bundle activo, repinta el drawer y recien ahi lo abre.
          if (!window.UvoraCart) throw new Error('No pudimos agregar al carrito');
          await window.UvoraCart.addBundle({
            items: [{ id: parseInt(variantId, 10), quantity: 1 }],
            replaceProductId: container.getAttribute('data-bundle-product-id')
          });
          if (txtSpan) txtSpan.textContent = originalText;
        } catch (err) {
          console.error(err);
          alert(err.message || 'Hubo un problema. Probá de nuevo.');
          if (txtSpan) txtSpan.textContent = originalText;
        } finally {
          addBtn.removeAttribute('aria-busy');
        }
      });
    }
  }

  document.querySelectorAll('[data-hero-gallery]').forEach(initGallery);
  document.querySelectorAll('[data-hero-bundles]').forEach(initBundles);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-hero-gallery]').forEach(initGallery);
    e.target.querySelectorAll('[data-hero-bundles]').forEach(initBundles);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-2"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initIngredientsCarousel(section) {
    if (section.dataset.bound === 'true') return;
    section.dataset.bound = 'true';

    var track = section.querySelector('[data-ic-track]');
    var prev = section.querySelector('[data-ic-prev]');
    var next = section.querySelector('[data-ic-next]');
    var progress = section.querySelector('[data-ic-progress]');
    if (!track) return;

    function getScrollStep() {
      var card = track.querySelector('.ingredients-carousel__card');
      if (!card) return 300;
      var style = window.getComputedStyle(track);
      var gap = parseInt(style.columnGap || style.gap || '16', 10);
      return card.offsetWidth + gap;
    }

    function updateUI() {
      var cards = track.querySelectorAll('.ingredients-carousel__card');
      var totalCards = cards.length;
      var maxScroll = track.scrollWidth - track.clientWidth;
      var current = track.scrollLeft;

      // Progreso basado en qué card está más cerca del centro del viewport
      var fillPct;
      if (totalCards > 0 && maxScroll > 0) {
        var trackRect = track.getBoundingClientRect();
        var trackCenter = trackRect.left + trackRect.width / 2;
        var closestIdx = 0;
        var closestDist = Infinity;
        cards.forEach(function (card, i) {
          var r = card.getBoundingClientRect();
          var cardCenter = r.left + r.width / 2;
          var dist = Math.abs(cardCenter - trackCenter);
          if (dist < closestDist) {
            closestDist = dist;
            closestIdx = i;
          }
        });
        // La card 0 = inicio de barra, la última = fin de barra
        fillPct = totalCards > 1
          ? (closestIdx / (totalCards - 1)) * 100
          : 100;
        // Mínimo visible para que la barra no quede en 0
        if (fillPct < 8) fillPct = 8;
      } else {
        fillPct = 100;
      }

      if (progress) progress.style.width = fillPct + '%';

      if (prev) {
        if (current <= 4) prev.setAttribute('disabled', '');
        else prev.removeAttribute('disabled');
      }
      if (next) {
        if (current >= maxScroll - 4) next.setAttribute('disabled', '');
        else next.removeAttribute('disabled');
      }
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -getScrollStep(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', updateUI, { passive: true });
    window.addEventListener('resize', updateUI);
    updateUI();
  }

  document.querySelectorAll('[data-ingredients-carousel]').forEach(initIngredientsCarousel);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-ingredients-carousel]').forEach(initIngredientsCarousel);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quiz"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initQuiz(quiz) {
    if (quiz.dataset.bound === 'true') return;
    quiz.dataset.bound = 'true';
    var steps = quiz.querySelectorAll('[data-step]');
    var results = quiz.querySelectorAll('[data-result]');
    var progress = quiz.querySelectorAll('[data-progress-step]');
    quiz.querySelectorAll('[data-quiz-answer]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.dataset.stepTarget;
        steps.forEach(function (s) { s.classList.remove('is-active'); });
        results.forEach(function (r) { r.classList.remove('is-active'); });
        if (target.indexOf('result') === 0) {
          quiz.querySelector('[data-result="' + target + '"]').classList.add('is-active');
          progress.forEach(function (p) { p.classList.add('is-complete'); });
        } else {
          var nextStep = quiz.querySelector('[data-step="' + target + '"]');
          if (nextStep) {
            nextStep.classList.add('is-active');
            progress.forEach(function (p) {
              var idx = parseInt(p.dataset.progressStep, 10);
              p.classList.toggle('is-active', idx <= parseInt(target, 10));
            });
          }
        }
      });
    });
  }
  document.querySelectorAll('[data-quiz]').forEach(initQuiz);
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('[data-quiz]').forEach(initQuiz); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-addtocart"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initStickyATC(bar) {
    if (bar.dataset.bound === 'true') return;
    bar.dataset.bound = 'true';

    // Regla 35: el disparador es el elemento configurado y, si no existe,
    // el boton principal del hero (#AddToCartBtn). Si no hay ninguno de los
    // dos, la barra se muestra SIEMPRE en vez de no activarse nunca.
    var triggerSelector = bar.dataset.showAfter || '.hero-product';
    var triggerEl = document.querySelector(triggerSelector) || document.getElementById('AddToCartBtn');
    var addBtn = bar.querySelector('[data-sticky-add]');
    var titleEl = bar.querySelector('[data-sticky-title]');
    var variantEl = bar.querySelector('[data-sticky-variant]');
    var priceEl = bar.querySelector('[data-sticky-price]');
    var priceOldEl = bar.querySelector('[data-sticky-price-old]');
    var imgEl = bar.querySelector('[data-sticky-image]');

    // Mensajes del boton: salen de los ajustes ("Mensajes del botón"); si
    // vienen vacios se usa el texto de siempre.
    function stxt(key, fallback) {
      return bar.getAttribute('data-text-' + key) || fallback;
    }

    function setVisible(show) {
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    // Regla 35: visibilidad por IntersectionObserver en vez de escuchar cada
    // scroll. La condicion es la misma de siempre -- la barra aparece cuando
    // el disparador ya quedo ARRIBA de la pantalla (bottom < 0), no cuando
    // todavia no llegamos a el -- asi no cambia el momento en que se ve.
    if (!triggerEl) {
      // Sin disparador la barra se muestra siempre, para no quedar
      // permanentemente oculta (fallback explicito de la regla 35).
      setVisible(true);
    } else if ('IntersectionObserver' in window) {
      var stickyObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          setVisible(!entry.isIntersecting && entry.boundingClientRect.bottom < 0);
        });
      }, { threshold: 0 });
      stickyObs.observe(triggerEl);
    } else {
      // Navegadores viejos: se mantiene el scroll con throttle.
      var ticking = false;
      var onScroll = function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          setVisible(triggerEl.getBoundingClientRect().bottom < 0);
          ticking = false;
        });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    function formatMoney(cents) {
      return '$' + Math.round(cents / 100).toLocaleString('es-AR');
    }

    // Sincronizacion VISUAL con el plan elegido (regla 34): precio, titulo,
    // imagen y el input del form nativo. El pedido que se manda al carrito NO
    // sale de aca -- se relee del radio tildado en el momento del click
    // (readSelectedBundle), asi no puede quedar desactualizado.
    function applyBundle(d) {
      if (!d) return;

      if (d.variantId && addBtn) addBtn.setAttribute('data-variant-id', d.variantId);
      // Mantener el input del form nativo en sincronia, para que el respaldo
      // sin JS tambien postee el plan elegido y no el del arranque.
      var hidden = bar.querySelector('[data-sticky-variant-input]');
      if (hidden && d.variantId) hidden.value = d.variantId;

      if (d.title && variantEl) variantEl.textContent = d.title;

      if (priceEl) {
        // priceText viene ya formateado por Liquid (money_without_trailing_zeros),
        // asi se ve identico al precio de la tarjeta. Los centavos son el fallback.
        if (d.priceText) priceEl.textContent = d.priceText;
        else if (d.priceCents) priceEl.textContent = formatMoney(d.priceCents);
      }

      if (priceOldEl) {
        var oldText = d.compareText || (d.compareAtCents ? formatMoney(d.compareAtCents) : '');
        if (oldText) {
          priceOldEl.textContent = oldText;
          priceOldEl.style.display = '';
        } else {
          priceOldEl.style.display = 'none';
        }
      }

      if (d.imageUrl && imgEl && imgEl.tagName === 'IMG') imgEl.src = d.imageUrl;
    }

    // Estado inicial: el hero es la primera seccion del template y ya emitio
    // el evento antes de que esta barra se inicializara, asi que lo leemos
    // del estado global que dejo guardado.
    if (window.UvoraBundleState) applyBundle(window.UvoraBundleState);

    document.addEventListener('bundle:selected', function (e) {
      applyBundle(e.detail);
    });

    // Lleva al bloque de planes (modo ancla, o cuando no hay variante conocida).
    function goToPlans() {
      var target = document.querySelector(bar.dataset.anchorTarget || '[data-hero-bundles]')
                || document.querySelector('[data-hero-bundles]');
      if (target && target.scrollIntoView) {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        window.location.href = '{{ routes.cart_url }}';
      }
    }

    // FUENTE DE VERDAD del pedido: el radio TILDADO en el hero, leido en el
    // instante del click. El evento bundle:selected se sigue usando, pero
    // SOLO para lo visual (precio, titulo, imagen): una copia guardada se
    // puede desactualizar, el DOM del selector no.
    // Devuelve null si en la pagina no hay tarjetas de planes del tema (estan
    // ocultas, borradas, o los planes los muestra una app).
    function readSelectedBundle() {
      var host = document.querySelector('[data-hero-buy-root]');
      if (!host || !host.querySelector('[data-bundle-radio]')) return null;
      var selected = host.querySelector('[data-bundle-radio]:checked');
      if (!selected || !selected.value) return { host: host, items: null };

      var items = [{ id: parseInt(selected.value, 10), quantity: 1 }];
      var upsellIds = [];
      var card = selected.closest('[data-bundle-card]');
      if (card) {
        card.querySelectorAll('[data-bundle-upsell].is-checked').forEach(function (up) {
          var vid = parseInt(up.getAttribute('data-upsell-variant-id') || '', 10);
          if (vid > 0) { items.push({ id: vid, quantity: 1 }); upsellIds.push(vid); }
        });
      }
      return { host: host, items: items, upsellIds: upsellIds, variantId: selected.value };
    }

    // Formulario de producto de la seccion principal (hero-product).
    function mainForm() {
      var root = document.querySelector('[data-hero-buy-root]');
      var id = root && root.getAttribute('data-form-id');
      return id ? document.getElementById(id) : null;
    }

    // Envia el formulario principal como si el comprador tocara el boton
    // principal: si el boton existe se le hace click (asi lo ven tambien las
    // apps que escuchan clicks); si esta oculto, se dispara el envio del form.
    function submitMainForm() {
      var form = mainForm();
      if (!form) return;
      var btn = document.querySelector('[data-hero-bundles-add]');
      if (btn && btn.form === form) { btn.click(); return; }
      if (typeof form.requestSubmit === 'function') { form.requestSubmit(); return; }
      var ev = new Event('submit', { bubbles: true, cancelable: true });
      if (form.dispatchEvent(ev)) form.submit();
    }

    // Muestra en la barra la variante que tiene el formulario principal en
    // este momento (cuando no hay tarjetas de planes del tema).
    var variantData = {};
    try {
      var vdEl = bar.querySelector('[data-sticky-variants]');
      if (vdEl) variantData = JSON.parse(vdEl.textContent) || {};
    } catch (e) {}

    function syncFromForm() {
      if (readSelectedBundle()) return; // con planes del tema manda bundle:selected
      var form = mainForm();
      var field = form && form.elements.namedItem('id');
      var vid = field && field.value;
      var d = vid && variantData[vid];
      if (!d) return;
      applyBundle({
        variantId: vid,
        title: d.title,
        priceText: d.priceText,
        compareText: d.compareText,
        imageUrl: d.imageUrl
      });
    }

    syncFromForm();
    // Las apps cambian el campo "id" del formulario; avisan con 'change' o
    // no avisan. Por eso se re-lee al cambiar algo y cada vez que la barra
    // aparece en pantalla.
    document.addEventListener('change', function () { syncFromForm(); }, true);
    var visObs = new MutationObserver(function () {
      if (bar.classList.contains('is-visible')) syncFromForm();
    });
    visObs.observe(bar, { attributes: true, attributeFilter: ['class'] });

    async function submitSticky() {
      if (!addBtn || addBtn.hasAttribute('aria-busy')) return;

      // Modo ancla: la compra la maneja la app de bundles, esta barra solo
      // lleva al selector de planes.
      if (bar.dataset.atcMode === 'anchor') { goToPlans(); return; }

      var selection = readSelectedBundle();
      var itemsToAdd, replaceProductId, trackedVariant;
      var trackedUpsells = [];

      if (selection) {
        // Hay selector de planes en la pagina: manda EXACTAMENTE lo tildado.
        // Si no hay nada tildado llevamos a los planes, en vez de agregar la
        // variante suelta a precio completo (ese era el bug reportado).
        if (!selection.items) { goToPlans(); return; }
        itemsToAdd = selection.items;
        trackedUpsells = selection.upsellIds || [];
        trackedVariant = selection.variantId;
        replaceProductId = selection.host.getAttribute('data-bundle-product-id');
      } else if (mainForm()) {
        // Sin planes del tema pero con formulario de producto en la pagina
        // (boton solo, o una app de bundles como Kaching): la barra compra
        // EXACTAMENTE por el mismo camino que el boton principal. Asi agrega
        // lo que haya elegido el comprador, venga de donde venga, y si la app
        // maneja la compra tambien la maneja aca.
        submitMainForm();
        return;
      } else {
        // No hay planes ni formulario en la pagina: recien ahi vale la
        // variante que renderizo Liquid en el boton.
        var variantId = addBtn.getAttribute('data-variant-id');
        if (!variantId) { goToPlans(); return; }
        itemsToAdd = [{ id: parseInt(variantId, 10), quantity: 1 }];
        trackedVariant = variantId;
        replaceProductId = bar.getAttribute('data-sticky-product-id');
      }

      addBtn.setAttribute('aria-busy', 'true');
      var longText = addBtn.querySelector('.sticky-atc__btn-text-long');
      var shortText = addBtn.querySelector('.sticky-atc__btn-text-short');
      var originalLong = longText ? longText.textContent : '';
      var originalShort = shortText ? shortText.textContent : '';
      if (longText) longText.textContent = stxt('adding', 'Agregando…');
      if (shortText) shortText.textContent = stxt('adding-short', '…');

      try {
          // Registrar los mismos pares bundle-upsell que registra el hero, para
          // que su limpieza de upsells huerfanos no borre nada de mas.
          if (trackedVariant && window.UvoraBundles && window.UvoraBundles.registerPairs) {
            window.UvoraBundles.registerPairs(
              String(trackedVariant),
              trackedUpsells.map(String)
            );
          }

          // Misma via de compra que el boton del hero: reemplaza las lineas
          // viejas de este producto, agrega, repinta y recien ahi abre el
          // drawer (theme.js -> UvoraCart.addBundle).
          if (!window.UvoraCart) throw new Error('cart-api-missing');
          await window.UvoraCart.addBundle({
            items: itemsToAdd,
            replaceProductId: replaceProductId
          });

          if (longText) longText.textContent = stxt('added', '✓ Agregado');
          if (shortText) shortText.textContent = stxt('added-short', '✓');

          setTimeout(function () {
            if (longText) longText.textContent = originalLong;
            if (shortText) shortText.textContent = originalShort;
          }, 1500);

        } catch (err) {
          console.error(err);
          // Si theme.js no cargo, el form nativo postea igual y la compra se
          // concreta (regla 60).
          if (err && err.message === 'cart-api-missing' && stickyForm) {
            stickyForm.submit();
            return;
          }
          // Mensaje en el propio boton en vez de un alert que tapa la pantalla.
          if (longText) longText.textContent = stxt('error', 'No se pudo agregar');
          if (shortText) shortText.textContent = stxt('error-short', 'Error');
          setTimeout(function () {
            if (longText) longText.textContent = originalLong;
            if (shortText) shortText.textContent = originalShort;
          }, 2500);
        } finally {
          addBtn.removeAttribute('aria-busy');
        }
    }

    // El boton es type="submit" dentro del form nativo (modo agregar).
    // stopPropagation evita un segundo /cart/add si otro listener escucha el
    // mismo submit (regla 78). Sin JS, el form postea solo y la compra anda.
    var stickyForm = bar.querySelector('[data-sticky-form]');
    if (stickyForm) {
      stickyForm.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();
        submitSticky();
      });
    }
    if (addBtn && !stickyForm) {
      addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        submitSticky();
      });
    }
  }

  document.querySelectorAll('[data-sticky-atc]').forEach(initStickyATC);

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-sticky-atc]').forEach(initStickyATC);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
